import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { WA, INSTA, TIKTOK, MAP_URL, MAP_EMBED } from '../../constants';
import { ExternalLink, SectionTitle } from '../ui';

const Contact = () => {
  return (
    <section id="contato" className="py-12 sm:py-20 lg:py-28 bg-mesh">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Entre em"
          highlight="Contato"
          description="Agende seu serviço ou tire suas dúvidas!"
        />

        <div className="max-w-2xl lg:max-w-4xl mx-auto space-y-4 sm:space-y-6">
          {/* WhatsApp */}
          <ExternalLink 
            href={WA} 
            className="glass-effect p-4 sm:p-5 rounded-2xl flex items-center gap-4 hover:border-green-500/50 transition-colors group"
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-green-500/20 rounded-xl flex items-center justify-center group-hover:bg-green-500/30 transition-colors flex-shrink-0">
              <FontAwesomeIcon icon={faWhatsapp} className="text-xl sm:text-2xl text-green-500" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm text-gray-500">WhatsApp</p>
              <p className="font-semibold text-sm sm:text-base">+55 48 9215-2728</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="text-gray-500 group-hover:text-green-500 transition-colors" />
          </ExternalLink>

          {/* Email */}
          <a 
            href="mailto:contato@goshine.com.br" 
            className="glass-effect p-4 sm:p-5 rounded-2xl flex items-center gap-4 hover:border-goshine-orange/50 transition-colors group"
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-goshine-orange/20 rounded-xl flex items-center justify-center group-hover:bg-goshine-orange/30 transition-colors flex-shrink-0">
              <FontAwesomeIcon icon={faEnvelope} className="text-xl sm:text-2xl text-goshine-orange" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm text-gray-500">E-mail</p>
              <p className="font-semibold text-sm sm:text-base truncate">contato@goshine.com.br</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="text-gray-500 group-hover:text-goshine-orange transition-colors" />
          </a>

          {/* Address */}
          <ExternalLink 
            href={MAP_URL} 
            className="glass-effect p-4 sm:p-5 rounded-2xl flex items-center gap-4 hover:border-goshine-purple-light/50 transition-colors group"
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-goshine-purple-light/20 rounded-xl flex items-center justify-center group-hover:bg-goshine-purple-light/30 transition-colors flex-shrink-0">
              <FontAwesomeIcon icon={faLocationDot} className="text-xl sm:text-2xl text-goshine-purple-light" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm text-gray-500">Endereço</p>
              <p className="font-semibold text-sm sm:text-base">R. Valter Mussi, 61 - Santa Monica</p>
              <p className="text-xs sm:text-sm text-gray-500">Florianópolis - SC</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="text-gray-500 group-hover:text-goshine-purple-light transition-colors" />
          </ExternalLink>

          {/* Social Links */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            <ExternalLink 
              href={INSTA} 
              className="glass-effect py-3 sm:py-4 flex items-center justify-center gap-2 sm:gap-3 hover:border-pink-500/50 transition-colors group rounded-xl"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-xl sm:text-2xl text-pink-500 group-hover:scale-110 transition-transform" />
              <span className="text-gray-300 text-sm sm:text-base">Instagram</span>
            </ExternalLink>
            <ExternalLink 
              href={TIKTOK} 
              className="glass-effect py-3 sm:py-4 flex items-center justify-center gap-2 sm:gap-3 hover:border-white/50 transition-colors group rounded-xl"
            >
              <FontAwesomeIcon icon={faTiktok} className="text-xl sm:text-2xl text-white group-hover:scale-110 transition-transform" />
              <span className="text-gray-300 text-sm sm:text-base">TikTok</span>
            </ExternalLink>
          </div>

          {/* Map */}
          <div className="glass-effect p-2 rounded-2xl overflow-hidden">
            <div className="mb-3 px-2 pt-2">
              <p className="text-white font-semibold text-sm flex items-center gap-2">
                <FontAwesomeIcon icon={faLocationDot} className="text-goshine-orange" />
                Nossa Localização
              </p>
            </div>
            <iframe 
              src={MAP_EMBED} 
              width="100%" 
              height="280" 
              style={{ border: 0, borderRadius: '0.75rem' }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade" 
              title="Localização GoShine" 
              className="sm:h-[300px] lg:h-[400px]" 
            />
            <ExternalLink 
              href={MAP_URL} 
              className="mt-3 flex items-center justify-center gap-2 bg-goshine-orange/20 hover:bg-goshine-orange/30 text-goshine-orange py-3 rounded-xl transition-colors text-sm font-medium"
            >
              <FontAwesomeIcon icon={faLocationDot} />
              Abrir no Google Maps
            </ExternalLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
